"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Avatar_1 = __importDefault(require("@mui/material/Avatar"));
const SvgIcon_1 = __importDefault(require("@mui/material/SvgIcon"));
const AvatarIcon = ({ backgroundColor, iconColor, icon }) => {
    return (react_1.default.createElement(Avatar_1.default, { sx: { backgroundColor, width: 32, height: 32 }, "data-testid": "avatar-icon" },
        react_1.default.createElement(SvgIcon_1.default, { sx: { color: iconColor, width: 20, height: 20 } }, icon)));
};
exports.default = AvatarIcon;
